<template>
  <div class="apRadio">
    <input
      :id="id"
      class="apRadio__input"
      name="radio"
      type="radio"
      :checked="checked"
    />
    <label
      :for="id"
      class="apRadio__label"
    >{{text}}</label>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    text: {
      type: String,
      default: 'Банковская карта'
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'radio'
    },

  }
});
</script>
<style lang="scss" scoped>
// .default{
.apRadio {
  display: flex;
  &__label {
    color: $primary-gray;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    font-family: "Open sans";
  }
  .apRadio__input{
    position: absolute;
    border: 1px solid black;
    visibility: hidden;
    + .apRadio__label {
      &:before {
        content: '';
        background: white;
        border: 2px solid $tele2-primary-gray;
        border-radius: 100%;
        display: inline-block;
        width: 21px;
        height: 21px;
        position: relative;
        top: -2.6px;
        margin-right: 10px;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .apRadio__label {
        &:before {
          background-color: $primary-purple;
          border: 2px solid $primary-purple;
          box-shadow: inset 0 0 0 3px white;
        }
      }
    }
  }
}
// }
.tele2{
.apRadio {
  display: flex;
  &__label {
    color: $tele2-primary-gray;
  }
  .apRadio__input{
    + .apRadio__label {
      &:before {
        content: '';
        border: 2px solid $tele2-primary-gray;
      }
    }
    &:checked {
      + .apRadio__label {
        &:before {
          background-color:$secondary-blue;
          border: 2px solid $secondary-blue;
        }
      }
    }
  }
}
}
.altel{
.apRadio {
  display: flex;
  &__label {
    color: $altel-primary-gray;
  }
  .apRadio__input{
    + .apRadio__label {
      &:before {
        content: '';
        border: 2px solid $altel-primary-gray;
      }
    }
    &:checked {
      + .apRadio__label {
        &:before {
          background-color:$primary-pink;
          border: 2px solid $primary-pink;
        }
      }
    }
  }
}
}
</style>